<script>
	// From Lucide
	import { ChevronsUp } from 'lucide-svelte';

	export let iconClass = '';
</script>

<ChevronsUp class={iconClass} />
